import React, { useCallback, useMemo, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const MAX_LINE_WIDTH = 110;

const Comments = ({ className, comments, isRecurring }) => {
  const { t } = useTranslation('OrdersOrderDetail');
  const [opened, setOpened] = useState(false);
  const onClick = useCallback(() => setOpened(true), []);
  const canExpand = !opened && comments.length >= MAX_LINE_WIDTH;

  const commentsToShow = useMemo(
    () =>
      canExpand ? `${comments.slice(0, MAX_LINE_WIDTH - 1)}...` : comments,
    [canExpand, comments]
  );

  const title = useMemo(
    () => t(`comments_section_title${isRecurring ? '_recurring' : ''}:`),
    [isRecurring, t]
  );
  const hideQuotes = commentsToShow.length === 1 && commentsToShow[0] === '';

  return (
    <div className={className} data-testid="comments">
      {comments.length > 0 ? (
        <div data-testid="comments_comment">
          <p className="label">{title}</p>
          <p data-e2e="shipmentComments" className="comments">
            {!hideQuotes && '"'}
            {commentsToShow}
            {!hideQuotes && '"'}
            {canExpand && (
              <Button
                data-testid="comments_button"
                nude
                skin="secondary"
                onClick={onClick}
                text={t('comments_see_more_link')}
              />
            )}
          </p>
        </div>
      ) : (
        <p className="label">{t('no_comments_placeholder')}</p>
      )}
    </div>
  );
};

Comments.propTypes = {
  className: PropTypes.string,
  comments: PropTypes.string,
  isRecurring: PropTypes.bool,
};

Comments.defaultProps = {
  comments: '',
  isRecurring: false,
};

export default Comments;
